import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import React, { Suspense, lazy } from 'react';
import Navbar from './components/pages/nav/navbar';
import Footer from './components/pages/footer/footer';
import ErrorBoundary from './components/pages/errorhandling/ErrorBoundary';
import NotFound from './components/pages/errorhandling/NotFound';

// Lazy Loading for Performance Optimization
const Home = lazy(() => import('./components/pages/home/home'));
const About = lazy(() => import('./components/pages/about/about'));
const Service = lazy(() => import('./components/pages/service/service'));
const ContactPage = lazy(
  () => import('./components/pages/contact/contactpage')
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Navbar />

        {/* Wrap the Entire App Inside ErrorBoundary */}
        <ErrorBoundary>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/service" element={<Service />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Protected Route */}

              {/* Login Route */}

              {/* 404 Not Found Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>

        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
